import { render, staticRenderFns } from "./SeatsV2.vue?vue&type=template&id=26498fc4&scoped=true&"
import script from "./SeatsV2.vue?vue&type=script&lang=js&"
export * from "./SeatsV2.vue?vue&type=script&lang=js&"
import style0 from "./SeatsV2.vue?vue&type=style&index=0&id=26498fc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26498fc4",
  null
  
)

export default component.exports